export const TOGGLE_INGREDIENTS = 'BEAMLY/CCX/TOGGLE_INGREDIENTS';

export const toggle = () => ({
  type: TOGGLE_INGREDIENTS,
});
